// src/components/SmsTestSimple.js

import React from 'react';
import '../styles/SmsTestSimple.css';

function SmsTestSimple() {
  const phoneNumber = '+19086457788';

  const handleFacialAppointment = () => {
    const message = 'I want to make an appointment to facial procedure';
    const smsLink = `sms:${phoneNumber}?body=${encodeURIComponent(message)}`;
    window.location.href = smsLink;
  };

  const handleConsultationRequest = () => {
    const message = 'I would like to schedule a consultation';
    const smsLink = `sms:${phoneNumber}?body=${encodeURIComponent(message)}`;
    window.location.href = smsLink;
  };

  return (
    <div className="sms-simple-container">
      <div className="sms-simple-content">
        <h1>Send SMS</h1>
        <p className="simple-description">Choose an option to send a text message</p>

        <div className="button-container">
          <button onClick={handleFacialAppointment} className="sms-btn facial-btn">
            📅 Facial Appointment
          </button>
          <button onClick={handleConsultationRequest} className="sms-btn consultation-btn">
            💬 Consultation Request
          </button>
        </div>

        <div className="info-box">
          <p>✉️ Recipient: <strong>{phoneNumber}</strong></p>
          <p className="info-note">Clicking a button will open your SMS app with the message ready to send.</p>
        </div>
      </div>
    </div>
  );
}

export default SmsTestSimple;
